import { NoResults } from '@clearkit/icons';
import { CKButton } from 'clearkit';

import * as Well from './Well';

type EmptyProps = {
  onRetry: () => void;
};
export function Empty({ onRetry }: EmptyProps) {
  return (
    <Well.Root>
      <Well.Icon>
        <NoResults />
      </Well.Icon>
      <Well.Content>
        <Well.Heading>We didn't find any custom objects</Well.Heading>
        <Well.Paragraph>
          We attempted to retrieve your custom objects from Salesforce but we
          didn't find any. If you think this is in error, please retry.
        </Well.Paragraph>
        <CKButton onClick={onRetry} variantColor="blue">
          Retry loading custom objects
        </CKButton>
      </Well.Content>
    </Well.Root>
  );
}
